// extracted by mini-css-extract-plugin
export default {"container":"GlanceStatsSmall_container__kKGAH"};